{
  "ui": {
    "feedback": "Zpětná vazba",
    "credits": "Tvůrci",
    "currentMaintainer": "Současný správce",
    "maintainerPeriod": "Od roku 2026",
    "originalTeam": "Původní tým",
    "creditsCampaigns": "Džungle a Vánoce",
    "moreSettings": "Další nastavení",
    "chooseLanguage": "Vyber si jazyk",
    "notebookTools": "Nástroje sešitu",
    "visualGuide": "Obrázkový průvodce",
    "templeSoon": "Již brzy",
    "playAdventure": "Hrát",
    "story": "Příběh",
    "loadingAdventure": "Chystáme se na dobrodružství…",
    "storyOpening": "Školní výlet do džungle. Marco a Sophia ji zkoumají s kamarády. Barevný pták upoutá Marcovu pozornost a on ho následuje mezi stromy. Najednou je sám. Pomoz průzkumníkům najít cestu!",
    "storyEnding": "Marco a Sophia společně dorazí ke ztracenému chrámu. Tajemná tvář střeží vchod. Čeká je nové dobrodružství!",
    "blockCategories": "Záložky sešitu",
    "actions": "Akce",
    "loops": "Smyčky",
    "conditions": "Podmínky",
    "title": "Run Marco! — Dobrodružství ve tvém sešitě",
    "home": "Úvodní stránka Run Marco",
    "map": "Mapa dobrodružství",
    "worlds": "Vyber si dobrodružství",
    "notebook": "Můj sešit",
    "notebookToggle": "Otevřít nebo zavřít sešit",
    "notebookOpen": "Otevřít sešit",
    "notebookClose": "Sledovat cestu",
    "page": "Strana {number}",
    "level": "Trasa {number}",
    "run": "Jdeme na to!",
    "stop": "Zastavit",
    "step": "Jeden krok",
    "stepTitle": "Provést jeden příkaz",
    "reset": "Zpět na start",
    "add": "Přidat",
    "addLabel": "Vyber blok k přidání",
    "addHint": "Spoj bloky a stiskni Hrát.",
    "undo": "Zpět",
    "clear": "Nová stránka",
    "hint": "Malá nápověda",
    "help": "Jak hrát",
    "settings": "Nastavení",
    "language": "Jazyk hry",
    "blockLanguage": "Jazyk bloků",
    "blockLanguageNote": "Pro bloky si můžeš vybrat jiný jazyk.",
    "musicOn": "Zapnout zvuk",
    "musicOff": "Vypnout zvuk",
    "sound": "Hudba a zvukové efekty",
    "speed": "Rychlost dobrodružství",
    "chooseExplorer": "Vyber si průzkumníka",
    "explorer": "Průzkumník",
    "marco": "Marco",
    "sophia": "Sophia",
    "close": "Zavřít",
    "done": "Pojďme objevovat!",
    "loading": "Hledáme cestu…",
    "loadError": "Dobrodružství se nepodařilo načíst. Obnov stránku a zkus to znovu.",
    "imageError": "Některé obrázky se nepodařilo načíst. Obnov stránku.",
    "gemGoal": "Najdi drahokam",
    "goal": "Najdi zlatou hvězdu",
    "cover": "Rozsviť každé políčko právě jednou",
    "lit": "Rozsvícená políčka: {count} / {total}",
    "explored": "Prozkoumané trasy: {count} / {total}",
    "facing": "Dívá se {direction} {arrow}",
    "boardLabel": "{name} na trase {level}, dívá se {direction}. {steps}. {objective}.",
    "up": "nahoru",
    "down": "dolů",
    "left": "doleva",
    "right": "doprava",
    "steps_one": "{count} krok",
    "steps_other": "{count} kroků",
    "blocks_one": "{count} blok",
    "blocks_other": "{count} bloků",
    "stars_one": "{count} hvězda",
    "stars_other": "{count} hvězd",
    "place": "Přidat bloky",
    "atEnd": "Na konec",
    "insideRepeat": "Do opakování {number}",
    "insideIf": "Do když {number}",
    "insideElse": "Do jinak {number}",
    "readyFirst": "Malý krok. Přidej blok dopředu a jdeme na to!",
    "ready": "Kam půjdeme? Připrav plán v sešitě.",
    "back": "Zpátky na startu. Bloky jsou připravené na další pokus.",
    "empty": "Nejdřív přidej blok do sešitu.",
    "win": "Cesta nalezena!",
    "winCover": "Celá cesta svítí!",
    "winDetails": "{steps} · {blocks}",
    "brilliant": "To bylo dobrodružství!",
    "simpler": "Zvládneš to s méně bloky?",
    "complete": "Trasa dokončena! Tvé nejlepší hvězdy jsou uložené.",
    "next": "Další trasa",
    "allWorlds": "Další dobrodružství",
    "replay": "Hrát znovu",
    "shortGoal": "Skoro! Přidej ještě pár bloků, ať dosáhneš na hvězdu.",
    "shortGem": "Skoro! Přidej ještě pár bloků, ať dosáhneš na drahokam.",
    "shortCover": "Některá políčka jsou ještě tmavá. Jak se k nim dostaneme?",
    "checking": "Prohlížíme cestu…",
    "paused": "Zastaveno. Hrát začne znovu od začátku.",
    "going": "Vyrážíme!",
    "stepped": "O krok blíž. Pokračuj tlačítkem Jeden krok nebo Hrát.",
    "clueCover": "Začni na kraji a projdi celý tvar. Skok přeskočí políčko, aniž by ho rozsvítil.",
    "clueCondition": "Podívej se na cestu před sebou. Podmínka pomáhá průzkumníkovi vybrat, co udělat.",
    "clueRepeat": "Které kroky se opakují? Vlož tento vzor do opakovacího bloku.",
    "clueForward": "Dopředu je směr, kterým se průzkumník dívá. Spočítej políčka ke hvězdě.",
    "clueGem": "Dopředu je směr, kterým se průzkumník dívá. Spočítej políčka k drahokamu.",
    "clueTurn": "Otočení mění směr bez pohybu. Sleduj cestu prstem.",
    "mapNote": "Vyber trasu. Tvé nejlepší hvězdy zůstanou uložené.",
    "mapLevel": "Trasa {number}: {name}. {stars}.",
    "locked": "Dokonči předchozí trasu, aby se tato odemkla.",
    "soundBlocked": "Klepni na tlačítko zvuku a uslyšíš dobrodružství.",
    "clearTitle": "Začít na nové stránce?",
    "clearNote": "Bloky této trasy se smažou. Tlačítko Zpět je může obnovit.",
    "keep": "Nechat moje bloky",
    "clearConfirm": "Smazat bloky",
    "fresh": "Nová stránka. Kam nás zavede tvůj další plán?",
    "localProgress": "Tvůj postup se ukládá na tomto zařízení.",
    "helpBuild": "Připrav plán",
    "helpBuildText": "Přetáhni bloky do sešitu a spoj je nebo je přidej klepnutím. Zvol „Do opakování“, když chceš přidat kroky do smyčky.",
    "helpTurn": "Sleduj průzkumníka",
    "helpTurnText": "Dopředu sleduje jeho pohled. Vlevo a vpravo otáčí na místě. Skok vede o dvě políčka dál.",
    "helpTry": "Zkus, sleduj a zkus znovu",
    "helpTryText": "Stiskni Hrát pro celý plán nebo Jeden krok pro jeden příkaz. Zakřivená šipka vrátí průzkumníka na start a zachová bloky.",
    "helpWorlds": "Každé dobrodružství má cíl",
    "helpWorldsText": "V Džungli najdi drahokam. Ve vánočním dobrodružství rozsviť každé volné políčko jednou. V Chrámu a Egejském moři dokonči opravy a zobrazené cíle a dojdi k východu.",
    "noTrail": "Tam není cesta! Zkus se nejdřív otočit.",
    "broken": "Ten most je rozbitý. Dokážeš ho přeskočit?",
    "blocked": "Něco překáží v cestě. Zkus skok nebo jinou trasu.",
    "alreadyLit": "To políčko už svítí. Navštiv každé políčko jen jednou.",
    "loopError": "Tento plán se opakuje donekonečna. Zkus změnit smyčku.",
    "repeatError": "Vyber počet opakování od 1 do 99.",
    "unsupported": "Odstraň nepodporovaný blok a zkus to znovu.",
    "connect": "Spoj bloky do jednoho řetězce a stiskni Hrát.",
    "path": "cesta",
    "steps_few": "{count} kroky",
    "blocks_few": "{count} bloky",
    "stars_few": "{count} hvězdy",
    "steps_many": "{count} kroku",
    "blocks_many": "{count} bloku",
    "stars_many": "{count} hvězdy",
    "backpack": "Batoh",
    "templeGems": "Drahokamy chrámu",
    "gemsCollected": "Drahokamy: {count} / {total}",
    "gemsReady": "Všechny drahokamy jsou nasbírané!",
    "aegeanTitle": "Tajemství Egejského moře",
    "harbour": "Přístav",
    "aegeanDescription": "Prozkoumej přístav: opravuj stanoviště, používej rutiny opakovaně a předávej číslo s každou zakázkou.",
    "templeBetaNote": "Beta · Hádanky a lekce právě upravujeme",
    "aegeanBetaNote": "Beta · První 3 úrovně v přístavu",
    "seasonal": "Sezónní dobrodružství",
    "choosePreview": "Vyber ukázkovou úroveň",
    "repairs": "Opravy",
    "reachExit": "Dojdi k východu",
    "taskRequirements": "Cíle úkolu",
    "lessonGuided": "Cvičení s pomocí · doplň připravený program",
    "lessonRepair": "Hledání chyb · oprav připravený program",
    "lessonChallenge": "Výzva · vytvoř vlastní program",
    "acc_define_parameter": "Rutina",
    "acc_call_argument": "Zavolat rutinu",
    "acc_repeat_parameter": "Opakovat podle vstupu",
    "parameter": "parametr",
    "argument": "předat",
    "callInput": "Vstup tohoto volání",
    "inputWaiting": "Spusť program nebo proveď jednu instrukci, aby se zobrazil další vstup.",
    "argumentMismatch": "Rutina s parametrem potřebuje volání s číslem. Bez parametru použij běžné volání.",
    "unsetParameter": "Parametr používej jen uvnitř rutiny, která ho přijímá. Parametry jsou oddělené od sdílené paměti.",
    "memoryObjective": "Zkontroluj záznam oprav a požadavky u východu. Každý program, který je splní, je přijat.",
    "gate": "Cesta je zablokovaná. Zkontroluj nedokončené opravy.",
    "noPickup": "Než nástroj sebereš, postav se na něj.",
    "creditLead": "Vedení týmu a vývoj softwaru",
    "creditArt": "Ilustrace a prostředí",
    "creditAnimation": "Animace",
    "creditUX": "Návrh rozhraní a uživatelské zkušenosti",
    "creditDesign": "Návrh hry",
    "creditStory": "Příběh",
    "creditAudio": "Hudba a zvuková technika",
    "lightLamp": "Rozsvítit lampu",
    "oilLamp": "Olejová lampa",
    "dustyStation": "zaprášené stanoviště",
    "betaLabel": "Beta",
    "noLamp": "Než lampu rozsvítíš, postav se na zhasnutou lampu.",
    "collected": "Nástroj sebrán · připraven k použití",
    "dustyPrompt": "Před použitím štětce se postav na zaprášené stanoviště.",
    "lampMissing": "Nejprve seber olejovou lampu. Podívej se do batohu.",
    "recursiveRoutine": "Tato rutina volá sama sebe. Použij jinou rutinu; rekurzivní volání zatím nejsou dostupná."
  },
  "content": {
    "jungle.title": "Výprava do džungle",
    "jungle.description": "Sleduj cestu ke ztracenému chrámu.",
    "jungle-1": "První kroky",
    "jungle-2": "O kousek dál",
    "jungle-3": "Za rohem",
    "jungle-4": "Změň směr",
    "jungle-5": "Sleduj cestu",
    "jungle-6": "Nová trasa",
    "jungle-7": "Nové cesty",
    "jungle-8": "Křižovatka v džungli",
    "jungle-9": "Najdi cestu",
    "jungle-10": "Mysli dopředu",
    "jungle-11": "Dlouhá cesta",
    "jungle-12": "Klikatá trasa",
    "jungle-13": "Odvážný skok",
    "jungle-14": "Objevují se vzory",
    "jungle-15": "Opakuj rytmus",
    "jungle-16": "Vyber cestu",
    "jungle-17": "Podívej se před skokem",
    "jungle-18": "Čti cestu",
    "jungle-19": "Chytrá oklika",
    "jungle-20": "Pod korunami stromů",
    "jungle-21": "Stavitel mostů",
    "jungle-22": "Za řekou",
    "jungle-23": "Prozkoumej ruiny",
    "jungle-24": "Kámen a dřevo",
    "jungle-25": "Větší skok",
    "jungle-26": "Sleduj stopy",
    "jungle-27": "Výš a výš",
    "jungle-28": "Objevuj dál",
    "jungle-29": "Klikaté cesty",
    "jungle-30": "Tajná zahrada",
    "jungle-31": "Skryté vzory",
    "jungle-32": "Prastaré stezky",
    "jungle-33": "Poslední zatáčky",
    "jungle-34": "K chrámu",
    "jungle-35": "Už tam skoro jsme",
    "jungle-36": "Ztracený chrám",
    "winter.title": "Zimní cesta",
    "winter.description": "Rozsviť každou stopu.",
    "winter-1": "Kroky ve sněhu",
    "winter-2": "Jiný směr",
    "winter-3": "Zmrzlé rohy",
    "winter-4": "Dlouhá oklika",
    "winter-5": "Sněhová vločka",
    "winter-6": "Zimní smyčky",
    "winter-7": "Průzkumník ledu",
    "winter-8": "Zákruty a zatáčky",
    "winter-9": "Ledová logika",
    "winter-10": "Hledač vzorů",
    "winter-11": "Mistr stezky",
    "winter-12": "Zimní zázrak",
    "temple.title": "Ztracený chrám",
    "temple.description": "Čtyřicet propojených místností. Oprav nebeský přístroj pomocí nástrojů, paměti a vlastních rutin."
  },
  "blockly": {
    "ARIA_LABEL_TRASH_EMPTY": "Koš je prázdný",
    "OPEN_TRASH": "Otevřít koš",
    "BLOCK_LABEL_BEGIN_STACK": "Začátek řetězce",
    "WORKSPACE_LABEL_1_STACK": "1 řetězec bloků",
    "WORKSPACE_LABEL_MANY_STACKS": "Řetězce bloků: %1",
    "ARIA_TYPE_FIELD_NUMBER": "číslo",
    "ARIA_TYPE_FIELD_DROPDOWN": "rozbalovací seznam",
    "ARIA_TYPE_FIELD_IMAGE": "obrázek",
    "WORKSPACE_LABEL_PLAIN": "Můj sešit",
    "FIELD_LABEL_EDIT_PREFIX": "Upravit %1",
    "BLOCK_LABEL_HAS_INPUT": "má vstup",
    "BLOCK_LABEL_HAS_INPUTS": "má vstupy",
    "BLOCK_LABEL_HAS_BRANCHES": "větve: %1",
    "FIELD_LABEL_OPTION_INDEX": "Možnost %1",
    "INPUT_LABEL_EMPTY": "Prázdné",
    "BLOCK_LABEL_DISABLED": "vypnuto",
    "BLOCK_LABEL_COLLAPSED": "sbaleno",
    "BLOCK_LABEL_BEGIN_PREFIX": "Začátek: %1",
    "INPUT_LABEL_END_STATEMENT": "Konec: %1",
    "ARIA_TYPE_FIELD_TEXT_INPUT": "text",
    "ARIA_TYPE_FIELD_INPUT": "vstup",
    "ARIA_TYPE_FIELD_TEXT_INPUT_ARGUMENT": "název vstupu",
    "ARIA_TYPE_FIELD_TEXT_INPUT_PROCEDURE": "název rutiny"
  }
}
